"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = void 0;
const react_1 = require("react");
const useRafState_1 = require("./useRafState");
/**
 * @deprecated Use import from @uxf/core-react instead.
 */
function useWindowSize() {
    const [state, setState] = (0, useRafState_1.useRafState)();
    (0, react_1.useEffect)(() => {
        const handler = () => setState({
            width: window.innerWidth,
            height: window.innerHeight,
        });
        handler();
        window.addEventListener("resize", handler);
        return () => window.removeEventListener("resize", handler);
    }, [setState]);
    return state;
}
exports.useWindowSize = useWindowSize;
